var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5889 22.1538V22.9231C19.5889 23.7391 19.2635 24.5218 18.6843 25.0988C18.1052 25.6758 17.3196 26 16.5006 26C15.6815 26 14.896 25.6758 14.3168 25.0988C13.7377 24.5218 13.4123 23.7391 13.4123 22.9231V22.1538M24.7849 20.588C23.5457 19.0769 22.6709 18.3077 22.6709 14.1418C22.6709 10.3269 20.7156 8.96779 19.1063 8.30769C18.8926 8.22019 18.6913 8.01923 18.6262 7.80048C18.3439 6.84327 17.5525 6 16.5006 6C15.4486 6 14.6568 6.84375 14.3774 7.80144C14.3122 8.0226 14.111 8.22019 13.8972 8.30769C12.286 8.96875 10.3327 10.3231 10.3327 14.1418C10.3303 18.3077 9.45541 19.0769 8.21624 20.588C7.70281 21.2139 8.15254 22.1538 9.05056 22.1538H23.9554C24.8486 22.1538 25.2954 21.2111 24.7849 20.588Z",
    stroke: "#4A5568",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.bc26bacb60d5c92f64d8d1702d9d302a.svg";
export { ForwardRef as ReactComponent };